
import Store from "@/store/index.js";
import axios from "axios";
const domain = Store.state.domain;

export default {
    async ObtenerParametro(data) {
        let response = await axios.post(`${domain.domainNameForApi}Indicadores/ObtenerParametro`, data);
        return response.data[0];
    },
}